import { useAuth } from "@/lib/config/auth-provider";

import { CONVERSATION_MODEL_INTERNAL_FLAG } from "@digital-twins/shared-types";

/**
 * Internal conversation options (`CONVERSATION_MODEL_INTERNAL_OPTIONS`, plan D3): the server
 * puts whether this viewer is verified Fairgen staff on `user.featureFlags.conversationModelInternal`
 * (never an org flag); this is the frontend read of that one key.
 */
export function useConversationModelInternalEnabled(): boolean {
  const { user } = useAuth();
  return user?.featureFlags?.[CONVERSATION_MODEL_INTERNAL_FLAG] === true;
}
